(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/components/cart-bottom-sheet.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/components/cart-bottom-sheet.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useState = _React.useState;
const _svs$ui$ReactBottomSh = svs.ui.ReactBottomSheet,
  BottomSheet = _svs$ui$ReactBottomSh.BottomSheet,
  BottomSheetFooter = _svs$ui$ReactBottomSh.BottomSheetFooter;
const _svs$ui$ReactGrid = svs.ui.ReactGrid,
  GridRow = _svs$ui$ReactGrid.GridRow,
  GridCol = _svs$ui$ReactGrid.GridCol;
const Envelope = svs.tur.Envelope;
const TicketOrderCounterWithPrice = svs.ticketsOrderHome.components.TicketOrderCounterWithPrice;
const getProductNameAndPrice = svs.ticketsOrderHome.utils.getProductNameAndPrice;
const formatCurrency = svs.utils.format.Currency;
const useIsMounted = svs.ticketsOrderHome.hooks.useIsMounted;
const CartIcon = () => React.createElement("svg", {
  fill: "none",
  height: "49",
  viewBox: "0 0 48 49",
  width: "48",
  xmlns: "http://www.w3.org/2000/svg"
}, React.createElement("g", {
  clipPath: "url(#clip0_2658_3013)"
}, React.createElement("path", {
  d: "M20.2041 41.3914C21.3146 41.3914 22.2232 42.3 22.2232 43.4105C22.2232 44.521 21.3146 45.4296 20.2041 45.4296C19.0936 45.4296 18.185 44.521 18.185 43.4105C18.185 42.3 19.0936 41.3914 20.2041 41.3914ZM20.2041 38.3628C17.4177 38.3628 15.1564 40.6242 15.1564 43.4105C15.1564 46.1968 17.4177 48.4582 20.2041 48.4582C22.9904 48.4582 25.2518 46.1968 25.2518 43.4105C25.2518 40.6242 22.9904 38.3628 20.2041 38.3628Z",
  fill: "#121C30"
}), React.createElement("path", {
  d: "M38.3758 41.3914C39.4863 41.3914 40.3949 42.3 40.3949 43.4105C40.3949 44.521 39.4863 45.4296 38.3758 45.4296C37.2653 45.4296 36.3567 44.521 36.3567 43.4105C36.3567 42.3 37.2653 41.3914 38.3758 41.3914ZM38.3758 38.3628C35.5895 38.3628 33.3281 40.6242 33.3281 43.4105C33.3281 46.1968 35.5895 48.4582 38.3758 48.4582C41.1622 48.4582 43.4235 46.1968 43.4235 43.4105C43.4235 40.6242 41.1622 38.3628 38.3758 38.3628Z",
  fill: "#121C30"
}), React.createElement("path", {
  d: "M13.0061 18.0911L12.7033 16.9302L11.8956 17.1422L13.0061 18.0911Z",
  fill: "#121C30"
}), React.createElement("path", {
  d: "M30.3197 9.08587V0L27.2911 0V9.08587H30.3197Z",
  fill: "#121C30"
}), React.createElement("path", {
  d: "M26.5214 10.5975L20.0967 4.17285L17.9551 6.31441L24.3798 12.7391L26.5214 10.5975Z",
  fill: "#121C30"
}), React.createElement("path", {
  d: "M33.2274 12.7406L39.6521 6.31592L37.5105 4.17436L31.0859 10.599L33.2274 12.7406Z",
  fill: "#121C30"
}), React.createElement("path", {
  d: "M27.2709 31.2958V22.21H24.2423V31.2958H27.2709Z",
  fill: "#121C30"
}), React.createElement("path", {
  d: "M33.3281 31.2958V22.21H30.2995V31.2958H33.3281Z",
  fill: "#121C30"
}), React.createElement("path", {
  d: "M12.6123 24.7337L15.9741 37.2621C16.1558 37.8981 16.7212 38.3625 17.4178 38.3625H40.5261C40.5867 38.3625 40.6473 38.3524 40.7079 38.3423C41.4347 38.3726 42.1414 37.8173 42.3736 36.9996L47.916 17.2328C48.1785 16.304 47.7343 15.3954 46.9266 15.1935C46.7247 15.143 46.5329 15.143 46.3209 15.143C46.2805 15.143 46.1089 15.143 45.9978 15.143H13.319L12.6325 12.5687L11.7946 9.5199C10.5024 5.51202 6.29261 3.22036 2.22416 4.32076L0.00317383 4.91639L0.820902 7.9753L3.04189 7.37967C4.26344 7.05662 5.55565 7.22824 6.64595 7.85415C7.73626 8.48007 8.53379 9.5199 8.85685 10.7414M14.1367 18.1717H44.5239L39.7084 35.3339H18.6595",
  fill: "#121C30"
})), React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0_2658_3013"
}, React.createElement("rect", {
  fill: "white",
  height: "48",
  width: "48"
}))));
const CartBottomSheet = _ref => {
  let children = _ref.children,
    tickets = _ref.tickets,
    totalOrderCount = _ref.totalOrderCount,
    totalOrderPrice = _ref.totalOrderPrice,
    shippingCost = _ref.shippingCost,
    decrementOrderCount = _ref.decrementOrderCount,
    incrementOrderCount = _ref.incrementOrderCount;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  const isMounted = useIsMounted();
  const onStateChange = state => {
    if (isMounted()) {
      setIsExpanded(state.state === 'expanded');
    }
  };
  return React.createElement(BottomSheet, {
    allowHeaderSwipe: true,
    behavior: "standard",
    bypassTabOrder: true,
    onStateChange: onStateChange
  }, isExpanded && React.createElement("div", {
    className: "padding-2",
    "data-testid": "cart-bottom-sheet-body"
  }, React.createElement("ul", {
    className: "cart-ticket-list"
  }, tickets.length === 0 && React.createElement("li", {
    className: "cart-ticket-list-item"
  }, React.createElement("div", {
    className: "h4 fw-500 w100 align-center padding-bottom-2"
  }, "Du har inga lotter i kundvagnen.")), tickets.map(ticket => React.createElement("li", {
    className: "cart-ticket-list-item",
    "data-testid": "cart-ticket-".concat(ticket.id),
    key: ticket.id
  }, React.createElement("div", {
    className: "u-flex w100"
  }, React.createElement("div", {
    className: "padding-right-1"
  }, React.createElement(Envelope, {
    bodyColor: "#FFFBCC",
    branding: "triss",
    className: "cart-envelope",
    image: ticket.image
  })), React.createElement(GridRow, {
    className: "flex-1"
  }, React.createElement(GridCol, {
    sm: 12,
    am: 12,
    md: 5,
    lg: 6
  }, React.createElement("div", {
    className: "h4 fw-500 padding-top-1"
  }, getProductNameAndPrice(ticket))), React.createElement(GridCol, {
    className: "align-content-end",
    sm: 12,
    am: 12,
    md: 7,
    lg: 6
  }, React.createElement(TicketOrderCounterWithPrice, {
    className: "flex-1",
    count: ticket.count,
    incrementDisabled: ticket.incrementDisabled,
    onDecrement: () => decrementOrderCount(ticket.id),
    onIncrement: () => incrementOrderCount(ticket.id),
    totalPrice: ticket.totalPrice
  })))))))), React.createElement(BottomSheetFooter, {
    className: "bg-white",
    customer: "tur"
  }, React.createElement("div", {
    className: "padding-h-2",
    "data-testid": "cart-bottom-sheet-footer"
  }, React.createElement("div", {
    className: "u-flex u-flex-align-items-center u-flex-justify-content-between padding-h-1 padding-bottom-1"
  }, React.createElement("div", null, React.createElement(CartIcon, null)), React.createElement("ul", {
    className: "cart-summary-list"
  }, React.createElement("li", {
    className: "cart-summary-list-item"
  }, React.createElement("div", null, "Antal:"), React.createElement("div", {
    className: "f-bold"
  }, totalOrderCount, " st")), React.createElement("li", {
    className: "cart-summary-list-item"
  }, React.createElement("div", null, "Porto:"), React.createElement("div", {
    className: "f-bold"
  }, shippingCost, " kr")), React.createElement("li", {
    className: "cart-summary-list-item"
  }, React.createElement("div", null, "Summa:"), React.createElement("div", {
    className: "f-bold"
  }, formatCurrency(totalOrderPrice), " kr")))), children)));
};
setGlobal('svs.ticketsOrderHome.components.CartBottomSheet', CartBottomSheet);

 })(window);